const json2form = (data: any): FormData => {
    const formdata = new FormData();
    // const params = new URLSearchParams();
    for (const key in data) {
        console.log('key', key)
        console.log('data', data[key])
        console.log('data type', Object.prototype.toString.call(data[key]))
        if (Object.prototype.toString.call(data[key]) === '[object Array]') {
            if(data[key].length>0){
                formdata.append(key, data[key][0].originFileObj);
            }
        }
        else {
            //[object String]  [object Number]
            formdata.append(key, data[key]);
        }
    }
    console.dir(formdata)
    return formdata
}
export default json2form